import Vue from "vue"
import App from "./App.vue"
import ElementUI from 'element-ui' // ElementUI组件库
import {Message} from 'element-ui'
//import {Calendar} from 'ant-design-vue';// ant-design-vue组件库
import 'element-ui/lib/theme-chalk/index.css'; // ElementUI组件库样式
// import 'ant-design-vue/dist/antd.css';// ant-design-vue组件库样式
import router from "./router/index.js" //路由器
import store from "./store" //vuex 状态管理器
import api from './api' // 导入api接口
import * as tool from './utils/tool' // 导入api接口
import lrz from 'lrz'
import './directives/index'
import dayjs from 'dayjs'
import format from 'vue-text-format'
import vue2Editor from "vue2-editor"
import 'element-ui/lib/theme-chalk/display.css';
// 注册饿了么UI
Vue.use(ElementUI)
// 注册金额格式化库
Vue.use(format)
// 注册AntDesignVue
//Vue.use(Calendar)
// vue富文本
Vue.use(vue2Editor);
Vue.config.productionTip = false
//-------------全局公共变量设定----------
Vue.prototype.$basicpath = "s";
Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.prototype.$tool = tool; // 将工具方法挂载到vue的原型上
Vue.prototype.$requestKey = "token"; // 将工具方法挂载到vue的原型上
Vue.prototype.$Copyrightc = "Copyrightc 2022-2044 Nomura Research Institute, Ltd. All rights reserved."
Vue.prototype.$BizMart = ""
Vue.prototype.$Message=Message
Vue.prototype.$dayjs = dayjs;//日期时间工具，有需要得引入
var base = {
  API_PATH: "", //需要证书验证，后端接口Vue.prototype.$requestKey"/s/api/v1"
  API_PATH_OPEN: "", //单独为注册、下载证书等服务开放特定接口
  WEB_PATH_CA: "", //需要证书验证的web域名
  WEB_PATH: "", //不需要证书验证的web域名
  WEB_PATH_HELP:""//不需要证书验证的帮助文档域名
}
if (process.env.NODE_ENV == 'development') {
  base.API_PATH = "//edi-v2-api.iy-test.svr/s/api/v1";
  base.API_PATH_OPEN = "//edi-api.iy-test.svr/s/api/v1";
  base.WEB_PATH_CA = "//edi-v2.iy-test.svr";
  base.WEB_PATH = "//edi.iy-test.svr";
  base.WEB_PATH_HELP = "//edi.iy-test.svr";
} else if (process.env.NODE_ENV == 'testing') {
  base.API_PATH = "//edi-v2-api.iy-test.svr/s/api/v1";
  base.API_PATH_OPEN = "//edi-api.iy-test.svr/s/api/v1";
  base.WEB_PATH_CA = "//edi-v2.iy-test.svr";
  base.WEB_PATH = "//edi.iy-test.svr";
  base.WEB_PATH_HELP = "//edi.iy-test.svr";
} else if (process.env.NODE_ENV == 'production') {
  base.API_PATH = "//edi-v2-api.iy-cd.com/s/api/v1";
  base.API_PATH_OPEN = "//edi-api.iy-cd.com/s/api/v1";
  base.WEB_PATH_CA = "//edi-v2.iy-cd.com";
  base.WEB_PATH = "//edi2.iy-cd.com";
  base.WEB_PATH_HELP = "//edi2.iy-cd.com";
}
Vue.prototype.$base = base;

Vue.prototype.$test = "def";
Vue.prototype.$angle = "s";
console.log("当前系统是" + process.env.NODE_ENV + "版，入口为 供应商入口：s")
//供应商入口
new Vue({
  el: "#app",
  components: {
    App
  },
  template: "<App/>",
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js